<template>
  <div class="consenttool">
    <div class="consentmodal" v-if="openModal">
      <transition name="show">
        <div class="consentinnter">
          <div class="black-bg"></div>
          <div class="container">
            <div class="columns is-centered">
              <div class="column is-8-tablet">
                <div class="consent">
                  <p class="h1" v-html="data.consent_title"></p>
                  <span v-html="data.consent_texttop"></span>
                  <div class="consentoption">
                    <div class="options disabled">
                      <span
                        v-bind:class="{ 'is-active': consentplaceholderone }"
                        ><span class="text">{{ data.consent_yes }}</span>
                        <input
                          v-model="consentplaceholderone"
                          type="radio"
                          id="consentplaceholderone"
                          class="true"
                          name="consentplaceholderone"
                          :value="true"
                          disabled
                        />
                      </span>
                      <span
                        v-bind:class="{ 'is-active': !consentplaceholderone }"
                        ><span class="text">{{ data.consent_no }}</span>
                        <input
                          v-model="consentplaceholderone"
                          type="radio"
                          id="consentplaceholderone"
                          class="false"
                          name="consentplaceholderone"
                          :value="false"
                          disabled
                        />
                      </span>
                    </div>
                    <div class="info">
                      <p v-html="data.consent_option1"></p>
                    </div>
                  </div>
                  <div class="consentoption">
                    <div class="options disabled">
                      <span
                        v-bind:class="{ 'is-active': consentplaceholdertwo }"
                        ><span class="text">{{ data.consent_yes }}</span>
                        <input
                          v-model="consentplaceholdertwo"
                          type="radio"
                          id="consentplaceholdertwo"
                          class="true"
                          name="consentplaceholdertwo"
                          :value="true"
                          disabled
                        />
                      </span>
                      <span
                        v-bind:class="{ 'is-active': !consentplaceholdertwo }"
                        ><span class="text">{{ data.consent_no }}</span>
                        <input
                          v-model="consentplaceholdertwo"
                          type="radio"
                          id="consentplaceholdertwo"
                          class="false"
                          name="consentplaceholdertwo"
                          :value="false"
                          disabled
                        />
                      </span>
                    </div>
                    <div class="info">
                      <p v-html="data.consent_option2"></p>
                    </div>
                  </div>
                  <div class="consentoption">
                    <div class="options">
                      <span v-bind:class="{ 'is-active': consentone }"
                        ><span class="text">{{ data.consent_yes }}</span>
                        <input
                          v-model="consentone"
                          type="radio"
                          id="consentone"
                          class="true"
                          name="consentone"
                          :value="true"
                        />
                      </span>
                      <span v-bind:class="{ 'is-active': !consentone }"
                        ><span class="text">{{ data.consent_no }}</span>
                        <input
                          v-model="consentone"
                          type="radio"
                          id="consentone"
                          class="false"
                          name="consentone"
                          :value="false"
                        />
                      </span>
                    </div>
                    <div class="info">
                      <p v-html="data.consent_option3"></p>
                    </div>
                  </div>
                  <span v-html="data.consent_textbottom"></span>
                  <a
                    @click="hideConsent()"
                    :href="data.more_info_link"
                    :title="data.consent_moreinfo"
                    >{{ data.consent_moreinfo }}</a
                  >
                  <div class="columns buttons">
                    <div class="column is-12 is-6-desktop">
                      <button
                        @click="acceptSettings($event)"
                        class="button normal accept"
                      >
                        <span class="text" v-html="data.button_save"></span>
                        <span class="bar"></span>
                      </button>
                    </div>
                    <div class="column is-12 is-6-desktop">
                      <button
                        @click="denySettings($event)"
                        class="button normal deny"
                      >
                        <span v-html="data.button_deny"></span>
                      </button>
                    </div>
                    <div class="column is-12">
                      <button
                        @click="acceptAll($event)"
                        class="button normal acceptall"
                      >
                        <span v-html="data.button_all"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
/* global wpApiSettings */

export default {
  data() {
    return {
      data: wpApiSettings.consenttool,
      openModal: false,
      consentplaceholderone: true,
      consentplaceholdertwo: true,
      consentone: false,
    };
  },
  mounted() {
    if (!this.$cookies.get("consent")) {
      this.openModal = true;
    }

    const consenttooltoggleID = document.getElementById("consenttooltoggle");
    if (
      typeof consenttooltoggleID != "undefined" &&
      consenttooltoggleID != null
    ) {
      consenttooltoggleID.addEventListener("click", () => {
        this.openModal = true;
      });
    }

    if (this.$cookies.get("consentone")) {
      this.consentone = JSON.parse(this.$cookies.get("consentone"));
    }
  },
  watch: {
    openModal(bol) {
      if (bol) {
        let body = document.getElementsByTagName("body")[0];
        let html = document.getElementsByTagName("html")[0];

        body.classList.add("is-active");
        html.classList.add("is-active");
      } else {
        let body = document.getElementsByTagName("body")[0];
        let html = document.getElementsByTagName("html")[0];

        body.classList.remove("is-active");
        html.classList.remove("is-active");
      }
    },
  },
  methods: {
    hideConsent() {
      this.$cookies.set("consent", true, "67d", null, null, null, "Strict");
    },
    showConsent() {
      if (!this.$cookies.get("consent")) {
        this.openModal = true;
      } else {
        if (JSON.parse(this.$cookies.get("consent"))) {
          this.openModal = false;
        } else {
          this.openModal = true;
        }
      }
    },
    acceptAll(e) {
      e.preventDefault();

      this.$cookies.set("consent", true, "67d", null, null, null, "Strict");
      this.openModal = false;

      this.consentone = true;
      this.setSettings();
    },
    denySettings(e) {
      e.preventDefault();

      this.$cookies.set("consent", true, "67d", null, null, null, "Strict");
      this.openModal = false;

      this.consentone = false;
      this.setSettings();
    },
    handleOpenConsent(e) {
      e.preventDefault();
      this.openModal = true;
    },
    acceptSettings(e) {
      e.preventDefault();

      if (!this.$cookies.get("consent")) {
        this.$cookies.set("consent", true, "67d", null, null, null, "Strict");
      }

      this.setSettings();
    },
    setSettings() {
      if (this.consentone) {
        this.$cookies.set(
          "consentone",
          true,
          "67d",
          null,
          null,
          null,
          "Strict"
        );
      } else {
        this.$cookies.set(
          "consentone",
          false,
          "67d",
          null,
          null,
          null,
          "Strict"
        );
      }
      setTimeout(function () {
        location.reload();
      }, 500);
    },
  },
};
</script>
